var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "frown",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8Zm0,46.774A21.774,21.774,0,1,1,46.774,33,21.8,21.8,0,0,1,25,54.774Zm0-15.323a15.049,15.049,0,0,0-11.573,5.423,1.61,1.61,0,1,0,2.47,2.067,11.845,11.845,0,0,1,18.185,0,1.61,1.61,0,1,0,2.47-2.067A14.977,14.977,0,0,0,25,39.452Zm-8.065-8.065a3.226,3.226,0,1,0-3.226-3.226A3.222,3.222,0,0,0,16.935,31.387Zm16.129,0a3.226,3.226,0,1,0-3.226-3.226A3.222,3.222,0,0,0,33.065,31.387Z",
    transform: "translate(0 -8)",
    fill: "#7c98b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown);
export default __webpack_public_path__ + "static/media/frown.0d7631f5199432642af72d63e3930cef.svg";
export { ForwardRef as ReactComponent };